import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Url, URLS } from '@wix/da-url';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import { BiData } from '@wix/da-bi/pkg/events';
import MenuList from '@wix/da-ds/pkg/Dropdown/MenuList';
import UserLink from '../../../../../../User/Link';
import VerificationReminder from '../../../../../_partials/VerificationReminder';
import { useCurrentUser } from '../../../../../../utils/hooks/useCurrentUser';
import { useBuyCoreItem, useLogoutItem, useThemeToggleItem, useContentFilterItem, useAISuppressionItem, useHelpItem, useSettingsItem, useStudioItem, usePointsBalanceItem, useCustomerDashboardItem, useEarningsItem, useBillingItem, useSaleBannerItem, usePushSubscriptionItem } from '../../../items';
import { UserMenuContext } from '../../UserMenuContext';
import UserMenuAvatar from '../UserMenuAvatar';
import userMenuStyles from './../../UserMenuMobile.scss';
import s from './LoggedInMenu.scss';
const LoggedInMenu = ({ hasSubscriptions, disableThemeSwitcher })=>{
    const { t } = useTranslation();
    const { isOpen: isUserMenuOpen } = useContext(UserMenuContext);
    const currentUser = useCurrentUser();
    const aiSuppressionItem = useAISuppressionItem();
    const contentFilterItem = useContentFilterItem();
    const themeToggleItem = useThemeToggleItem();
    const saleBannerItem = useSaleBannerItem();
    const logoutItem = useLogoutItem();
    const buyCoreItem = useBuyCoreItem();
    const helpItem = useHelpItem();
    const settingsItem = useSettingsItem();
    const studioItem = useStudioItem();
    const pointsBalanceItem = usePointsBalanceItem();
    const customerDashboardItem = useCustomerDashboardItem();
    const earningsItem = useEarningsItem();
    const billingItem = useBillingItem();
    const pushSubscriptionItem = usePushSubscriptionItem();
    const { verificationEmail } = useContext(SessionContext);
    const tabIndex = isUserMenuOpen ? 0 : -1;
    const subscriptionsUrl = Url.userSubscriptionsLink({
        username: currentUser.username
    });
    const userAvatarItem = {
        label: /*#__PURE__*/ React.createElement(UserLink, {
            user: currentUser,
            className: s['user-link'],
            showSymbol: false,
            tabIndex: tabIndex
        }),
        suffix: /*#__PURE__*/ React.createElement(UserMenuAvatar, null)
    };
    const userSubscriptionsItem = hasSubscriptions && {
        label: t('siteHeader.userMenu.mySubscriptions'),
        link: subscriptionsUrl,
        biData: BiData({
            evid: 702,
            link_url: subscriptionsUrl,
            menu_item: 'my_subscriptions',
            menu_name: 'profile'
        }),
        tabIndex
    };
    const statsGroupItems = [
        {
            label: t('siteHeaderMobile.userMenu.monetizeMyArt'),
            newTag: true,
            link: `${URLS.SHOP}?utm_source=DA&utm_medium=navbar&utm_campaign=DA_mobile_navbar&utm_id=DA_mobile_nav`,
            target: '_blank',
            biData: BiData({
                evid: 702,
                link_url: URLS.SHOP_TOP_NAV,
                menu_item: 'monetizeMyArt',
                menu_name: 'profile'
            }),
            tabIndex
        },
        pointsBalanceItem,
        earningsItem,
        billingItem,
        customerDashboardItem
    ];
    const lastGroupItems = [
        !disableThemeSwitcher && themeToggleItem,
        contentFilterItem,
        aiSuppressionItem,
        settingsItem,
        pushSubscriptionItem,
        helpItem,
        logoutItem
    ];
    return /*#__PURE__*/ React.createElement(MenuList, {
        renderOnSSR: true,
        id: "site-header-user-menu",
        className: userMenuStyles['user-menu'],
        itemsFillContainerWidth: true,
        items: [
            {
                className: userMenuStyles['top-group'],
                items: [
                    userAvatarItem,
                    buyCoreItem,
                    !verificationEmail ? userSubscriptionsItem : null,
                    !verificationEmail ? studioItem : null,
                    saleBannerItem
                ]
            },
            verificationEmail ? {
                label: /*#__PURE__*/ React.createElement(VerificationReminder, {
                    email: verificationEmail
                }),
                className: s['verification-group']
            } : {
                className: userMenuStyles['group'],
                items: statsGroupItems
            },
            {
                className: userMenuStyles['group'],
                items: lastGroupItems
            }
        ]
    });
};
LoggedInMenu.displayName = 'LoggedInMenu';
export default LoggedInMenu;

//# sourceMappingURL=LoggedInMenu.js.map